import { ogyTrackingEvent } from '../ad-container/ad-container';
import { FormatNotifier } from '../format-notifier/format-notifier';
import { ExperienceEntryPoint } from '../static-media-entry-point/experience-entry-point';
import { CreativeTagEvent } from '../enums';

export class MotionlyReadyEventHandler {
  constructor(
    private readonly formatNotifier: FormatNotifier,
    private readonly experienceEntryPoint: ExperienceEntryPoint
  ) {
    this.attachEventHandler();
  }

  private attachEventHandler() {
    this.experienceEntryPoint.addEventListener(
      CreativeTagEvent.CreativeAssetLoad,
      () => {
        this.formatNotifier.notify(ogyTrackingEvent.OCS_LOADED);
      }
    );
  }
}
